import { render } from "./BaseGraph.vue?vue&type=template&id=4a9ee6df&ts=true"
import script from "./BaseGraph.vue?vue&type=script&lang=ts"
export * from "./BaseGraph.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__